import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { Menu, Info, HardHat } from 'lucide-react';
import { IS_DEMO } from '@/core/environment';
import { APP_NAME } from '@/config/branding';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-[#010409] text-gray-100 flex-col">
            {IS_DEMO && (
                <div className="bg-gradient-to-r from-amber-600 to-orange-600 text-white px-4 py-2 flex items-center justify-between text-xs font-medium z-50 shadow-lg shadow-amber-500/10">
                    <div className="flex items-center gap-2">
                        <Info size={14} />
                        <span>ESTÁS EN MODO DEMO — Los datos son de ejemplo y no se guardarán.</span>
                    </div>
                    <div className="flex items-center gap-4">
                        <a href="https://vitonhub.pages.dev" className="underline hover:text-amber-100 transition-colors">Descargar App Escritorio</a>
                    </div>
                </div>
            )}
            <div className="flex flex-1 overflow-hidden relative">
                <Sidebar
                    isOpen={sidebarOpen}
                    toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                />

                {/* Mobile Header */}
                <div className="fixed top-0 left-0 right-0 h-14 bg-[#0d1117]/95 backdrop-blur-xl border-b border-white/8 flex items-center px-4 md:hidden z-30">
                    <button onClick={() => setSidebarOpen(true)} className="p-2 text-gray-400 hover:text-gray-200 transition-colors">
                        <Menu size={24} />
                    </button>
                    <div className="ml-3 flex items-center gap-2">
                        <div className="w-7 h-7 bg-gradient-to-br from-amber-400 to-orange-600 rounded-lg flex items-center justify-center">
                            <HardHat size={14} className="text-white" />
                        </div>
                        <span className="font-bold text-base bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">{APP_NAME}</span>
                    </div>
                </div>

                {/* Main Content Area */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden md:ml-60 pt-14 md:pt-0">
                    <div className="container mx-auto px-4 py-6 md:px-8 md:py-8 max-w-7xl">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
